import { OscEnvironment } from '@osc-utils/enums/osc-environments';
import { environment } from 'src/environments/environment';

export const getEnvironment = (): OscEnvironment => OscEnvironment[environment.name];
export const getPlayStoreId = (): string => environment.playStoreId;
export const getAppStoreId = (): string => environment.appStoreId;
